export default __webpack_public_path__ + "assets/icons/header-lang.37b2a47c.svg";